import React, { useState, useContext } from 'react';
import UserContext from '../context/UserContext';
import { api } from '../utils/apiHelper';
import '../styles/MemBidCreate.css';

const MemBidCreate = () => {
  const { authUser } = useContext(UserContext);
  const [items, setItems] = useState([
    { title: '', description: '', offer: '', shortCode: generateShortCode(), files: [] },
  ]);
  const [successMessage, setSuccessMessage] = useState('');
  const [uploading, setUploading] = useState(false);

  function generateShortCode() {
    return Math.random().toString(36).substring(2, 8).toUpperCase();
  }

  const handleChange = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = value;
    setItems(updated);
  };

  const handleFileChange = (index, e) => {
    const updated = [...items];
    updated[index].files = [...e.target.files];
    setItems(updated);
  };

  const uploadFileToS3 = async (file, shortCode) => {
    const s3Req = {
      fileName: file.name,
      fileType: file.type,
      accessType: 'public-read',
      userId: authUser._id,
      projectId: shortCode,
    };

    const s3Res = await api('/s3-url', 'POST', s3Req);
    if (!s3Res?.url || !s3Res?.key) throw new Error('S3 URL generation failed');

    await fetch(s3Res.url, {
      method: 'PUT',
      headers: { 'Content-Type': file.type },
      body: file,
    });

    return {
      key: s3Res.key,
      fileName: file.name,
      type: file.type,
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setUploading(true);
      for (const item of items) {
        const { title, offer, files, shortCode } = item;
        if (!title || !offer) {
          alert('Each item must have a title and offer amount.');
          continue;
        }

        const fileKeys = [];
        for (const file of files) {
          const meta = await uploadFileToS3(file, shortCode);
          fileKeys.push(meta);
        }

        const payload = {
          userId: authUser._id,
          title: item.title,
          description: item.description,
          price: offer,
          shortCode,
          fileKeys,
        };

        await api('/mem-bid-create', 'POST', payload);
      }

      setSuccessMessage('All bid items created!');
      setItems([{ title: '', description: '', offer: '', shortCode: generateShortCode(), files: [] }]);
    } catch (err) {
      console.error('Error submitting items:', err.message);
    } finally {
      setUploading(false);
    }
  };

  const addItem = () => {
    setItems([...items, { title: '', description: '', offer: '', shortCode: generateShortCode(), files: [] }]);
  };

  if (authUser?.email !== 'support@editfarmer.com') return null;

  return (
    <div className="create-bid-container">
      <h2>Enter Items</h2>
      {successMessage && <p className="success-message">{successMessage}</p>}
      <form onSubmit={handleSubmit}>
        {items.map((item, index) => (
          <div key={index} className="bid-item-block">
            <label>Title*</label>
            <input type="text" value={item.title} onChange={(e) => handleChange(index, 'title', e.target.value)} required />

            <label>Description</label>
            <textarea value={item.description} onChange={(e) => handleChange(index, 'description', e.target.value)} />

            <label>Offer ($)*</label>
            <input type="number" value={item.offer} onChange={(e) => handleChange(index, 'offer', e.target.value)} required />

            {/* Hidden File Upload */}
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={(e) => handleFileChange(index, e)}
              style={{ display: 'none' }}
            />

            <label>Short Code</label>
            <div className="code-preview">{item.shortCode}</div>

            <hr />
          </div>
        ))}

        <button type="button" onClick={addItem}>+ Add Another Item</button>
        <button type="submit" disabled={uploading}>
          {uploading ? 'Submitting...' : 'Submit All Items'}
        </button>
      </form>
    </div>
  );
};

export default MemBidCreate;
